import React from "react";
import withProviders from "../../hooks/withProviders";
import { FilterProvider, FeeManagementDefaultFilters } from "../../hooks/FilterContext";
import HeadOfficeDebtorManagement from "../../features/headofficedebtormanagement";

const DebtorManagementPage = () => <HeadOfficeDebtorManagement />

export default withProviders([FilterProvider, { defaultFilters: FeeManagementDefaultFilters, filterStore: 'admin.management.debtors' }])(DebtorManagementPage);
